// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2qSE7","calendarButtons":"ClockData_calendarButtons__34P3f"};